export const formMessage = {
	PHONE: 'Введите номер телефона',
	PASSWORD: 'Введите пароль',
}
